webpackJsonp([1],{

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MARGINS = 6,
    minWidth = 20,
    minHeight = 20;
// FULLSCREEN_MARGINS = -10

/* harmony default export */ var App = ({
    name: 'app',
    data: function data() {
        return {
            fileList: [],
            file: null,
            x: 0,
            y: 0,
            w: 100,
            h: 100,
            cursor: 'default',

            mProps: {
                b: null,
                x: 0,
                y: 0,
                onTopEdge: false,
                onLeftEdge: false,
                onRightEdge: false,
                onBottomEdge: false
            },

            output: ''
        };
    },

    computed: {
        paneClass: function paneClass() {
            return {
                width: this.w + 'px',
                height: this.h + 'px',
                top: this.y + 'px',
                left: this.x + 'px',
                cursor: this.cursor
            };
        }
    },
    watch: {
        file: function file() {
            if (this.file) {
                this.$refs.img.src = URL.createObjectURL(this.file.file);
            }
        }
    },
    methods: {
        keydown: function keydown(e) {
            var catched = true;

            switch (e.key) {
                case 'ArrowLeft':
                    if (e.shiftKey) {
                        this.w--;
                        if (e.altKey) this.h = this.w;
                    } else if (e.altKey) {
                        this.x -= 10;
                    } else {
                        this.x--;
                    }
                    break;
                case 'ArrowUp':
                    if (e.shiftKey) {
                        this.h--;
                        if (e.altKey) this.w = this.h;
                    } else if (e.altKey) {
                        this.y -= 10;
                    } else {
                        this.y--;
                    }
                    break;
                case 'ArrowRight':
                    if (e.shiftKey) {
                        this.w++;
                        if (e.altKey) this.h = this.w;
                    } else if (e.altKey) {
                        this.x += 10;
                    } else {
                        this.x++;
                    }
                    break;
                case 'ArrowDown':
                    if (e.shiftKey) {
                        this.h++;
                        if (e.altKey) this.w = this.h;
                    } else if (e.altKey) {
                        this.y += 10;
                    } else {
                        this.y++;
                    }
                    break;
                case ('ShiftLeft', 'ShiftRight'):
                    this.w = this.h;
                    break;
                case ('Space', 'Enter'):
                    this.record();
                    break;
                default:
                    catched = false;
            }
            if (catched) {
                e.stopPropagation();
                e.preventDefault();
                this.regularCoords();
            }
        },
        getCircle: function getCircle(p) {
            return {
                left: p.x,
                top: p.y,
                width: p.w,
                height: p.h
            };
        },
        record: function record() {
            if (this.file) {
                this.file.rects.push({
                    x: this.x,
                    y: this.y,
                    w: this.w,
                    h: this.h
                });
            }
        },
        load: function load(p) {
            this.x = p.x;
            this.y = p.y;
            this.w = p.w;
            this.h = p.h;
        },
        regularCoords: function regularCoords() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            this.w = Math.round(this.w);
            this.h = Math.round(this.h);
        },
        calc: function calc(e) {
            this.mProps.b = this.$refs.pane.getBoundingClientRect();
            this.mProps.x = e.clientX - this.mProps.b.left;
            this.mProps.y = e.clientY - this.mProps.b.top;

            this.mProps.onTopEdge = this.mProps.y < MARGINS;
            this.mProps.onLeftEdge = this.mProps.x < MARGINS;
            this.mProps.onRightEdge = this.mProps.x >= this.mProps.b.width - MARGINS;
            this.mProps.onBottomEdge = this.mProps.y >= this.mProps.b.height - MARGINS;
        },
        canMove: function canMove() {
            return this.mProps.x > 0 && this.mProps.x < this.mProps.b.width && this.mProps.y > 0 && this.mProps.y < this.mProps.b.height;
        },
        mdPane: function mdPane(e) {
            this.calc(e);

            var isResizing = this.mProps.onRightEdge || this.mProps.onBottomEdge || this.mProps.onTopEdge || this.mProps.onLeftEdge;

            this.clicked = {
                x: this.mProps.x,
                y: this.mProps.y,
                cx: e.clientX,
                cy: e.clientY,
                w: this.mProps.b.width,
                h: this.mProps.b.height,
                isResizing: isResizing,
                isMoving: !isResizing && this.canMove(),
                onTopEdge: this.mProps.onTopEdge,
                onLeftEdge: this.mProps.onLeftEdge,
                onRightEdge: this.mProps.onRightEdge,
                onBottomEdge: this.mProps.onBottomEdge
            };

            e.target.focus();
        },
        muPane: function muPane(e) {
            this.clicked = null;
        },
        mmPane: function mmPane(e) {
            this.calc(e);
            var clicked = this.clicked;

            if (this.clicked) {
                if (this.clicked.isResizing) {
                    if (clicked.onRightEdge) {
                        this.w = Math.max(this.mProps.x, minWidth);
                    }
                    if (clicked.onBottomEdge) {
                        this.h = Math.max(this.mProps.y, minHeight);
                    }

                    if (clicked.onLeftEdge) {
                        var currentWidth = Math.max(clicked.cx - e.clientX + clicked.w, minWidth);
                        if (currentWidth > minWidth) {
                            this.w = currentWidth;
                            this.x = e.clientX;
                        }
                    }

                    if (clicked.onTopEdge) {
                        var currentHeight = Math.max(clicked.cy - e.clientY + clicked.h, minHeight);
                        if (currentHeight > minHeight) {
                            this.h = currentHeight;
                            this.y = e.clientY;
                        }
                    }
                } else if (clicked.isMoving) {
                    this.y = e.clientY - clicked.y + this.$refs.main.scrollTop;
                    this.x = e.clientX - clicked.x + this.$refs.main.scrollLeft;
                }
                this.regularCoords();
                return;
            }

            if (this.mProps.onRightEdge && this.mProps.onBottomEdge || this.mProps.onLeftEdge && this.mProps.onTopEdge) {
                this.cursor = 'nwse-resize';
            } else if (this.mProps.onRightEdge && this.mProps.onTopEdge || this.mProps.onBottomEdge && this.mProps.onLeftEdge) {
                this.cursor = 'nesw-resize';
            } else if (this.mProps.onRightEdge || this.mProps.onLeftEdge) {
                this.cursor = 'ew-resize';
            } else if (this.mProps.onBottomEdge || this.mProps.onTopEdge) {
                this.cursor = 'ns-resize';
                // } else if (this.canMove()) {
                //     this.cursor = 'move'
            } else {
                this.cursor = 'default';
            }
        },
        make: function make() {
            var line;
            this.output = '';
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.fileList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var f = _step.value;

                    if (f.rects.length) {
                        line = f.name + ' ' + f.rects.length;
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(f.rects), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var p = _step2.value;

                                line += ' ' + (p.x + 2) + ' ' + (p.y + 2) + ' ' + (p.w + 2) + ' ' + (p.h + 2);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        this.output += line + '\n';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (this.output) {
                this.copyTextToClipboard();
            }
        },
        copyTextToClipboard: function copyTextToClipboard() {
            var textArea = document.createElement('textarea');

            textArea.style.visible = 'hidden';
            textArea.value = this.output;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                var successful = document.execCommand('copy');
                var msg = this.$t('message.' + (successful ? 'successful' : 'unsuccessful'));
                alert(this.$t('message.copying') + msg);
            } catch (err) {
                alert(this.$t('message.copyErr'));
            }
            document.body.removeChild(textArea);
        },
        openFile: function openFile(e) {
            this.file = {
                name: e.target.files[0].name,
                rects: [],
                file: e.target.files[0]
            };
            this.fileList.push(this.file);
        },
        del: function del(i) {
            this.file.rects.splice(i, 1);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6964868b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"main",staticClass:"main",on:{"mouseup":_vm.muPane,"mousemove":_vm.mmPane}},[_c('img',{ref:"img"}),(_vm.file)?_vm._l((_vm.file.rects),function(p,i){return _c('div',{key:"i",staticClass:"circle",style:({top:p.y + p.h/2 + 'px', left:p.x + p.w/2 + 'px'}),on:{"click":function($event){_vm.load(p)}}})}):_vm._e(),_c('div',{ref:"pane",style:(_vm.paneClass),attrs:{"id":"pane","tabindex":"1"},on:{"dblclick":_vm.record,"keydown":_vm.keydown,"mousedown":function($event){$event.preventDefault();_vm.mdPane($event)}}})],2),_c('div',{staticClass:"side"},[_c('input',{ref:"if",attrs:{"type":"file","id":"fileInput","name":"file","accept":"image/*"},on:{"change":_vm.openFile}}),_c('div',[_c('button',{on:{"click":function($event){_vm.$refs.if.click()}}},[_vm._v(_vm._s(_vm.$t("message.addFile")))]),_c('button',{on:{"click":_vm.make}},[_vm._v(_vm._s(_vm.$t("message.copy")))])]),_c('div',{staticClass:"file-list"},[_c('h4',[_vm._v(_vm._s(_vm.$t("message.files")))]),_c('ul',[_vm._l((_vm.fileList),function(f){return _c('li',{key:f.name,class:{active:f==_vm.file},on:{"click":function($event){_vm.file=f}}},[_vm._v(_vm._s(f.name))])}),(_vm.fileList.length==0)?_c('li',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t("message.noImageFiles")))]):_vm._e()],2)]),(_vm.file)?_c('div',{staticClass:"positions"},[_c('h4',[_vm._v("\b"+_vm._s(_vm.$t("message.markers")))]),_c('ul',[_vm._l((_vm.file.rects),function(p,i){return _c('li',{key:"i",on:{"click":function($event){_vm.load(p)}}},[_vm._v(_vm._s(i+1)+": "+_vm._s(p.x)+" "+_vm._s(p.y)+" "+_vm._s(p.w)+" "+_vm._s(p.h)),_c('span',{on:{"click":function($event){_vm.del(i)}}},[_vm._v("X")])])}),(_vm.file.rects.length==0)?_c('li',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$t("message.noMarkers")))]):_vm._e()],2)]):_vm._e(),_c('div',[_c('h4',[_vm._v(_vm._s(_vm.$t("message.result")))]),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.output),expression:"output"}],ref:"out",domProps:{"value":(_vm.output)},on:{"input":function($event){if($event.target.composing){ return; }_vm.output=$event.target.value}}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("S+uL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

vue_esm["a" /* default */].config.productionTip = false;

var messages = {
  'en-US': {
    message: {
      addFile: 'Add File',
      copy: 'Make & Copy',
      files: 'Files',
      noImageFiles: 'no image file',
      noMarkers: 'no rect selected, double click rect selecotr to add',
      markers: 'Markers',
      result: 'result',
      successful: 'successful',
      unsuccessful: 'unsuccessful',
      copyErr: 'Oops, unable to copy',
      copying: 'Copying '
    }
  },
  'zh-CN': {
    message: {
      addFile: '添加文件',
      copy: '复制',
      files: '文件',
      noImageFiles: '请先添加图像文件',
      noMarkers: '还没有任何选中标记，在选择框上双击即可添加',
      markers: '标记',
      result: '结果预览',
      successful: '成功',
      unsuccessful: '失败',
      copyErr: '复制失败！',
      copying: '复制'
    }
  }
};

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: navigator.language,
  messages: messages
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  i18n: i18n,
  components: { App: src_App }
});

/***/ }),

/***/ "S+uL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8deadd1e6e07ea82e1bd.js